
import { List, ListBody, ListWrapper } from '../../../BTUI/List';
import { Button } from '../../../components/Button';
import PanelLayout from '../../panelComponents/PanelLayout/PanelLayout';
import './style.css';
import { RiDeleteBin6Line } from "react-icons/ri";
import { useEffect, useState } from 'react';
import authService from '../../../service/auth';
import ToggleButton from '../../../components/ToggleButton';
import { showDatetime } from '../../../utils/formatter';

const ExecutiveList = () => {
    const [executiveList, setExecutiveList] = useState([]);

    useEffect(()=>{
        authService?.executivesList()
            .then((res) => {
                console.log("exec list",res);
                setExecutiveList(res?.data?.response?.execList)
            })
            .catch((err) => {
                console.log("list",err);
            });
    },[])

    useEffect(()=>{
        executiveList?.map((executive,index) => {
            if(executive?.id_status === "ACTIVE"){
                
            }
        })
    })

    const handleToggle = (name, value, index) => {
        // Update the local state
        const updatedExecutiveList = [...executiveList];
        updatedExecutiveList[index].id_status = value;
        setExecutiveList(updatedExecutiveList);
    
        // Update the database value
        const executiveId = executiveList[index].id; // Assuming there's an id property in your executive object
        authService.updateExecutiveStatus(executiveId, value)
            .then((res) => {
                console.log("Updated executive status:", res);
            })
            .catch((err) => {
                console.error("Error updating executive status:", err);
                // Rollback the local state update if the request fails
                setExecutiveList(executiveList);
            });
    }
    return<PanelLayout>
        {/* <Center> */}
            {/* <Button varient="action-btn" bgColor="primary" title={`Add New executive`} onClick={()=>navigate('')}/> */}
        {/* </Center> */}
        <br/>
        <ListWrapper>
            <List thead={Thead} title="Executives" actionBtnTitle="Add New Executive" href="/executive/add">
                <ListBody>
                    {executiveList?.length>0 ? executiveList?.map((executive,index) => {
                        return <tr key={index}>
                            <td>{index+1}</td>
                            <td>{executive?.email}</td>
                            <td>{executive?.added_on && showDatetime(executive?.added_on)}</td>
                            <td>{executive?.user_type}</td>
                            <td>{executive?.verify_status}</td>
                            <td>
                                {executive?.id_status} 
                                <ToggleButton 
                                    name="id_status"
                                    value={executive?.id_status}
                                    handleChange={(name,value)=>handleToggle(name,value,index)}
                                />

                            </td>
                            <td style={{display: 'flex'}}>
                                
                                <Button title={<RiDeleteBin6Line />} varient="icon" onClick={()=>alert('delete')} />
                            </td>
                        </tr>
                    }) : <p style={{textAlign: 'center', marginTop: '20px'}}>No Record Found</p>}
                </ListBody>
            </List>
        </ListWrapper>
    </PanelLayout>
}

export default ExecutiveList;

const Thead = [
    {
        title: 'Sr. No',
        width: '5%'
    },
    {
        title: 'Email',
        width: '15%'
    },
    {
        title: 'Added on',
        width: '15%'
    },
    {
        title: 'User Type',
        width: '15%'
    },
    {
        title: 'Verify Status',
        width: '15%'
    },
    {
        title: 'Status',
        width: '15%'
    },
    {
        title: 'Action',
        width: '15%'
    },
]